<template>
  <Screen>
    <AppBar :title="title" />
    <Breadcrumbs
      :links="[
        {
          to: $route('admin.categories.categories.index'),
          title: 'Categories',
        },
      ]"
      :title="title"
    />
    <div class="row">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <form
              action=""
              method="post"
              @submit.prevent="submit"
              v-if="formSet"
            >
              <div class="row">
                <div class="col-lg-6">
                  <TextBox
                    name="name"
                    v-model="form.name"
                    :disabled="form.processing"
                    :error="form.errors.name"
                  />
                </div>
                <div class="col-lg-6">
                  <TextBox
                    label="Name in arabic"
                    name="name_ar"
                    v-model="form.name_ar"
                    :disabled="form.processing"
                    :error="form.errors.name_ar"
                    lang="ar"
                  />
                </div>
              </div>
              <TextBox
                name="slug"
                v-model="form.slug"
                :disabled="form.processing"
                :error="form.errors.slug"
              />
              <FileInput
                name="image"
                v-model="form.image"
                :fileUrl="form.image_url"
                :disabled="form.processing"
                :error="form.errors.image"
              />
              <FileInput
                name="icon"
                v-model="form.icon"
                :fileUrl="form.icon_url"
                :disabled="form.processing"
                :error="form.errors.icon"
              />
              <div class="row">
                <div class="col">
                  <StatusRadio
                    v-model="form.is_active"
                    :disabled="form.processing"
                    :error="form.errors.is_active"
                  />
                </div>
                <div class="col">
                  <StatusRadio
                    label="Is featured"
                    :radioLabel="['Yes', 'No']"
                    name="is_featured"
                    v-model="form.is_featured"
                    :disabled="form.processing"
                    :error="form.errors.is_featured"
                  />
                </div>
              </div>

              <div class="mt-4 text-center">
                <button
                  class="btn btn-primary w-25"
                  type="submit"
                  :disabled="form.processing"
                  @click.prevent="submit"
                >
                  <div
                    class="spinner-border spinner-border-sm"
                    role="status"
                    v-if="form.processing"
                  ></div>
                  <span v-else>Save</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Screen>
</template>
<script>
import _ from "lodash";
import FileInput from "@/components/form/fileInput.vue";

export default {
  components: {
    FileInput,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    formData: {
      type: [Object, Array],
      default: () => {},
    },
    submitUrl: {
      type: String,
      default: "",
    },
  },
  watch: {
    "form.name": {
      handler(value) {
        if (this.formSet) {
          this.form.slug = _.kebabCase(value);
        }
      },
    },
  },
  data() {
    return {
      form: {},
      formSet: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.form = this.$inertia.form(this.formData);
      this.form.icon = null;
      this.form.image = null;
      setTimeout(() => {
        this.formSet = true;
      });
    });
  },
  methods: {
    submit() {
      this.form.post(this.submitUrl, {
        onSuccess: () => this.form.reset(),
      });
    },
  },
  computed: {},
};
</script>
